import React from 'react';
import { ReplyIcon } from './icons';
import { useTranslationContext } from '../../context/TranslationContext';
var UnMemoizedMessageRepliesCountButton = function (props) {
    var labelPlural = props.labelPlural, labelSingle = props.labelSingle, onClick = props.onClick, _a = props.reply_count, reply_count = _a === void 0 ? 0 : _a;
    var t = useTranslationContext('MessageRepliesCountButton').t;
    if (!reply_count)
        return null;
    var replyCountText = t('replyCount', { count: reply_count });
    if (labelPlural && reply_count > 1) {
        replyCountText = reply_count + " " + labelPlural;
    }
    else if (labelSingle) {
        replyCountText = "1 " + labelSingle;
    }
    return (React.createElement("button", { className: 'str-chat__message-replies-count-button', "data-testid": 'replies-count-button', onClick: onClick },
        React.createElement(ReplyIcon, null),
        replyCountText));
};
export var MessageRepliesCountButton = React.memo(UnMemoizedMessageRepliesCountButton);
